import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Typography, useTheme, useMediaQuery } from '@mui/material';

// import './marquee.css';
import card1 from '../assets/cards/card1.png';
import card2 from '../assets/cards/card2.png';
import card3 from '../assets/cards/card3.png';
import card4 from '../assets/cards/card4.png';
import card5 from '../assets/cards/card5.png';
import card6 from '../assets/cards/card6.png';
import card7 from '../assets/cards/card7.png';
import card8 from '../assets/cards/card8.png';

const images = [
  { src: card1, alt: 'Expert Card' },
  { src: card2, alt: 'Expert Card' },
  { src: card3, alt: 'Expert Card' },
  { src: card4, alt: 'Expert Card' },
  { src: card5, alt: 'Expert Card' },
  { src: card6, alt: 'Expert Card' },
  { src: card7, alt: 'Expert Card' },
  { src: card8, alt: 'Expert Card' },
];

const Marquee = ({ images }) => {
  const navigate = useNavigate(); // Используется, но не влияет на логику Marquee
  const marqueeRef = useRef(null);
  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isLg = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
  const isMd = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const bp = isXl ? 'xl' : isLg ? 'lg' : isMd ? 'md' : isSm ? 'sm' : 'xs';

  const [marqueeWidth, setMarqueeWidth] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const allImages = [...images, ...images,  ...images]; // Дублируем изображения для бесшовной прокрутки

  // Эффект для отслеживания загрузки изображений
  useEffect(() => {
    let loadedCount = 0;
    const imageElements = marqueeRef.current ? marqueeRef.current.querySelectorAll('img') : [];

    if (imageElements.length === 0) {
      setImagesLoaded(true);
      return;
    }

    const handleImageLoad = () => {
      loadedCount++;
      if (loadedCount === imageElements.length) {
        setImagesLoaded(true);
      }
    };

    imageElements.forEach(img => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
      }
    });

    return () => {
      imageElements.forEach(img => {
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, [allImages.length]); // Зависимость от количества изображений

  // Эффект для расчета ширины после загрузки изображений и смены брейкпоинта
  useEffect(() => {
    if (imagesLoaded && marqueeRef.current) {
      let singleSetWidth = 0;
      // Мы должны вычислить ширину ОДНОГО набора изображений
      // Обратите внимание: мы берем только ПЕРВУЮ половину children (т.е. оригинальные изображения)
      // или можем просто использовать `images.length` для итерации по оригинальным изображениям
      // Если все изображения имеют одинаковую ширину (что вероятно для карусели),
      // можно просто взять ширину первого и умножить. Но лучше быть точным.

      const children = Array.from(marqueeRef.current.children); // Преобразуем в массив для удобства
      // Берем ширину только первого набора изображений
      for (let i = 0; i < images.length; i++) { // Итерируем только по количеству ОРИГИНАЛЬНЫХ изображений
        const child = children[i];
        if (child) {
          // Используем getBoundingClientRect().width для большей точности
          singleSetWidth += child.getBoundingClientRect().width;
        }
      }

      // Общая ширина marquee должна быть удвоенной шириной ОДНОГО набора
      setMarqueeWidth(singleSetWidth * 3);

      // console.log('Single set width:', singleSetWidth); // Для отладки
      // console.log('Marquee width (total):', singleSetWidth * 2); // Для отладки
    }
  }, [imagesLoaded, bp, images.length]); // Добавил images.length в зависимости

  return (
    <Box
      sx={{
        overflow: 'hidden',
      }}
    >
      <Box
        className="image-marquee"
        ref={marqueeRef}
        style={{
          width: `${marqueeWidth}px`, // Динамически установленная ширина
          // overflow: 'hidden',
          whiteSpace: 'nowrap',
          display: 'flex',
          animation: imagesLoaded && marqueeWidth > 0 ? 'marquee 12s linear infinite' : 'none', // Запускаем анимацию только после загрузки и расчета ширины
        }}
      >
        {allImages.map((image, index) => (
          <Box
            component="img"
            key={index}
            src={image.src}
            alt={image.alt}
            sx={{
              flexShrink: 0, // Предотвращает сжатие
              height: { xs: '16rem' },
              width: { xs: '14rem' }, // Важно: фиксированная ширина
              px: { xs: '1rem' }, // padding (это 2rem к общей ширине элемента)
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export function ExpertCards() {
  return (
    <>
      <Box sx={{}}>
        <Container sx={{
          mb: '4vh',
          flexGrow: 1,
        }}>
          <Typography variant="h3">
            Converse with the Future
          </Typography>
        </Container>

        <Marquee images={images} />
      </Box>
    </>
  );
}

export default ExpertCards;